import mockData from '../mocks';

const USE_MOCK_DATA = process.env.MODE === 'development';

export const getDataSource = (type) => {
  if (USE_MOCK_DATA && type !== 'publications') {
    return mockData[type];
  }

  // For publications, always use the real API
  if (type === 'publications') {
    return null; // This will make the store fall back to using the real API
  }

  // For other services in production
  return mockData[type];
};
